<script lang="ts">
    import { smartRounding } from '../../telematics/tools/smartRounding/index.js';
    import { _ } from 'svelte-i18n';
    import { debug } from '../../../../stores/store';
    import { reactiveTooltip } from '../../../utilities/reactiveTooltip.js';
    import RouteCostDetails from './RouteCostDetails.svelte';

    export let estimation: boolean = false;
    export let cost: number | null = null;
    export let currency: string = '';
    export let details: Record<string, (number|null)[]> | null = null;
    export let tooltipPosition: string = 'top';

    let costHumanFriendly: string = '';

    $: {
        if ($debug) {
            cost = 123456;
        }
        if (cost !== null) {
            costHumanFriendly = new smartRounding().getFormatedValue(cost, '', {
                convert_nicer: true,
            });
        } else {
            costHumanFriendly = '';
        }
    }
</script>

<div class="dont-break" use:reactiveTooltip={{enabled: cost && details !== null, content: {component: RouteCostDetails, props: {details, currency, total: cost}}, theme: 'lastmile-tooltip', maxWidth: 400, position: tooltipPosition}}>
    <div style="display: flex; align-items: baseline;" class:estimation class="dont-break">
        {#if costHumanFriendly}
            <div class="dont-break">{costHumanFriendly}</div>
            <div class="lite" style="padding:0 0 0 2px; font-size: 12px;">
                {currency}
            </div>
        {/if}
    </div>
</div>

<style>
    .estimation {
        font-weight: 400;
        opacity: 0.5;
    }
</style>
